import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Stethoscope, FlaskConical, AlertTriangle, IndianRupee, Users } from "lucide-react";
import AdminLayout from "@/pages/admin/AdminLayout";
import KpiCard from "@/components/KpiCard";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [kpis, setKpis] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/admin/dashboard").then(({ data }) => setKpis(data));
  }, []);

  const goToClinics = (params = "") => navigate(`/ali-admin-portal/clinics${params}`);

  return (
    <AdminLayout>
      <h1 className="text-2xl font-semibold text-slate-900" data-testid="admin-dashboard-heading">
        Platform Overview
      </h1>
      <p className="mt-1 text-sm text-slate-600">Cross-tenant metrics for the RootLyst SaaS platform.</p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <KpiCard testId="kpi-total-clinics" label="Total Clinics" value={kpis?.total_clinics ?? "—"} icon={Building2} onClick={() => goToClinics()} />
        <KpiCard testId="kpi-active-doctors" label="Active Doctors" value={kpis?.active_doctors ?? "—"} icon={Stethoscope} onClick={() => goToClinics("?status=ACTIVE")} />
        <KpiCard testId="kpi-trial-clinics" label="Trial Clinics" value={kpis?.trial_clinics ?? "—"} icon={FlaskConical} onClick={() => goToClinics("?plan=TRIAL")} />
        <KpiCard
          testId="kpi-expired-subscriptions"
          label="Expired Subscriptions"
          value={kpis?.expired_subscriptions ?? "—"}
          icon={AlertTriangle}
          accent="text-red-600"
          onClick={() => goToClinics("?expired=true")}
        />
        <KpiCard
          testId="kpi-monthly-revenue"
          label="Monthly Revenue"
          value={kpis ? `₹${kpis.monthly_revenue.toLocaleString("en-IN")}` : "—"}
          icon={IndianRupee}
          accent="text-teal-700"
          onClick={() => goToClinics("?paid=true")}
        />
        <KpiCard
          testId="kpi-today-revenue"
          label="Today's Revenue"
          value={kpis ? `₹${kpis.today_revenue.toLocaleString("en-IN")}` : "—"}
          icon={IndianRupee}
          onClick={() => goToClinics("?paid=true")}
        />
        <KpiCard testId="kpi-leads" label="Leads" value={kpis?.leads ?? "—"} icon={Users} onClick={() => navigate("/ali-admin-portal/leads")} />
      </div>
    </AdminLayout>
  );
}
